import React from "react"
import Layout from "../components/layout"
import { Link } from "gatsby"

const AboutPage = () => {
  return (
    <Layout>
      
      <h2>About</h2>
      <h3>A Brief Introduction</h3>
      <div className ="text-grid-1">
      <p>
        I work in the vicinity of digital media, specialising in computational
        graphic design. I write code to make engaging works from
        websites to art installations. Beyond client work, I research
        and develop open source tools for pedagogical and artistic practice.
        I am also committed to teaching as a means for exchange and the passing
        on of knowledge in an area of design I believe to be of importance. I
        strive for craftmanship and pursue life with humble yet ambitious zeal.
      </p>
      </div>
      <div className ="text-grid-1">
            <p>
                If you are interested in learning more about my work or would be interested in reaching out for a future collaboration, please email me at mark.webster[at]wanadoo.fr. You can equally follow me on <a href="https://twitter.com/motiondesign_01">Twitter </a>where I sporadically post little visual experiments and information on projects in the making.
            </p>
            </div>
      <h3>Digging Deeper</h3>
      <div className ="text-grid-1">
      <p>The information that follows is a selection of lectures, workshops, events and writings. You will find links to various webpages that may shed more light on these various projects. If you would like to learn more about my creative process, please click on the <Link to="process">Process menu.</Link></p>
      </div>

      <br></br>
      <h2>Selected Workshops & Installations</h2>
      <hr align="left"></hr>
      <div className ="text-grid-1">
      <p>Workshops have always been an important part of my teachings and often I get to work on installations too. Workshops are always oriented towards fixed objectives in which I try to get participants engaged in a particular technique or theme, all the while directing them towards personal expression and some final piece of work.</p>
      </div>
      <br></br>
      
      <div class="grid-layout-col2">
        <p id="title">
          <a href="http://www.georgeandfriends.xyz/">George & Friends</a>
        </p>
        <p>
          Various locations. 2018 - current
        </p>
        <p id="title">
          <a href="http://parametric.esac-cambrai.net/">Parametrics</a>
        </p>
        <p>
          ESAC Cambrai, France, 2018
        </p>
        <p id="title">
          <a href="https://samdraws.bitbucket.io/logs/log013.html">SAM The Drawing Machine</a>
        </p>
        <p>
          Centre Pompidou Paris, 2017
        </p>
        <p id="title">
          Lettres Ornées
        </p>
        <p>
          ESAL Metz, 2017
        </p>
        <p id="title">
          <a href="http://workshop-lettrine-01.esad-amiens.fr/">Lettres Ornées</a>
        </p>
        <p>
          ESAD. Amiens, 2016
        </p>
        <p id="title">
          <a href="https://bitbucket.org/mwebster_/for-loops-forever/src/master/">Boucles FOR Ever</a>
        </p>
        <p>
          Paris College of Art, 2014
        </p>
        <p id="title">
          On Algorithmics & Aesthetics
        </p>
        <p>
          Musée d’Art Contemporain de Bordeaux, 2013
        </p>
        <p id="title">
          Designing Programs
        </p>
        <p>
          ESAL Metz, 2013, 2014, 2016, 2017
        </p>
        <p id="title">
          Designing Programs
        </p>
        <p>
          ESAV. Marrakech, 2012 - 2015
        </p>
        <p id="title">
          Systèmes Graphiques
        </p>
        <p>
          L’Université de Reims, 2012 & 2013
        </p>
        <p id="title">
          Visual Systems
        </p>
        <p>
          Paris College of Art, 2013
        </p>
        <p id="title">
          Persistence of Visions
        </p>
        <p>
          Graphic Design Festival. Breda, 2012
        </p>
        <p id="title">
          Creative Code & Silkscreen
        </p>
        <p>
          École d’Art d’Aix-en-Provence, 2012
        </p>
        <p id="title">
          <a href="https://delure.org/en/les-rencontres/rencontres-precedentes/rencontres-2010">La Typographie Générative</a>
        </p>
        <p>
          Rencontres Internationales de Lure Festival, 2011
        </p>
        <p id="title">
          Algorithmes Sérigraphies
        </p>
        <p>
          La Fabrique Pola, Bordeaux, 2011
        </p>
      </div>
      <br></br>

      <h2>Selected Lectures</h2>
      <hr align="left"></hr>
      <div className ="text-grid-1">
      <p>
        I've had the great opportunity to talk extensively about the role of
        generative and computational approaches in graphic design and art at
        large. Most of my talks refer to a variety of contemporary artists and
        designers as well as occasionaly digging into the past history of
        algorithmic art. It has equally been a great pleasure to organise events
        around creative coding and invite many talented speakers to share their
        precious knowledge.
      </p>
      </div>
      <br></br>

      <div class="grid-layout-col2">
        <p id="title"><a href="http://giants.esad-amiens.fr/">On The Shoulder Of Giants</a></p>
        <p>ESAD d’Amiens, France, 2018</p>

        <p id="title">Code, dessin & SAM</p>
        <p>La Librairie Mollat, Bordeaux, 2017</p>
        <p id="title">Textes & Transformations</p>
        <p>École Supérieure d’Art de Lorraine, 2016</p>
        <p id="title">Designing Programs</p>
        <p>UFR des Arts, Amiens, 2016</p>

        <p id="title"><a href="https://cargocollective.com/mwebster/Processing-Paris">Processing Paris</a></p>
        <p>La Fonderie de l'Image, Paris 2010 - 2015</p>
        <p id="title"><a href="http://codesign.esad-amiens.fr/">co:de/*sign;</a></p>
        <p>ESAD d’Amiens, France, 2014</p>
        <p id="title">Design Génératif</p>
        <p>ESAV Marrakech, Morocco, 2014</p>
        <p id="title">Looking Back to The Beginnings of Computer Art.</p>
        <p>Hochschule für Künste. Bremen, Germany, 2013</p>
        <p id="title">Design Génératif</p>
        <p>FRAC Centre Turbulences d’Orléans, France, 2013</p>
        <p id="title">Design Génératif</p>
        <p>Montpellier, France, 2013</p>
        <p id="title">Designing Programs</p>
        <p>Rencontres Internationales de Lure Festival. Lure, France, 2010</p>
      </div>

      <br></br>

      <h2>Selected Writings & Publications</h2>
      <hr align = "left"></hr>
      <div className ="text-grid-1">
      <p>Some of my works have made the press and I have also dabbled in a few writings for notable magazines. Writing is a means for articulating the finer parts of what observation often leaves bare and visceral. It helps shape and sharpen one's intellect.</p>
      </div>
      <br></br>
      <div class="grid-layout-col2">
      
        <p id="title">
          <a href="https://www.wiley.com/en-us/Becoming+a+Graphic+and+Digital+Designer%3A+A+Guide+to+Careers+in+Design%2C+5th+Edition-p-9781118771983">Becoming a Graphic & Digital Designer</a>
        </p>
        <p>
          Steven Heller & Véronique Vienne, 2016
        </p>
        <p id="title">
          <a href="http://www.eyemagazine.com/feature/article/go-with-the-data-flow">Go With The Data Flow</a>
        </p>
        <p>
          Eye Magazine Spring, 2013
        </p>
        <p id="title">
          100 Assignments: The Future of The Foundation Course in Art & Design
        </p>
        <p>
          PCA Presse, 2013
        </p>
        <p id="title">
          <a href="https://vimeo.com/markwebster">A Selection of Video Interviews</a>
        </p>
        <p>
          DesignFlux, 2009 - 2012
        </p>
        <p id="title">
          <a href="https://etapes.com/">Processing In Process</a>
        </p>
        <p>
          Étapes N°206, 2012
        </p>
        <p id="title">
          <a href="http://www.eyemagazine.com/review/article/seeds-of-digital-romanticism">Seeds of Digital Romanticism</a>
        </p>
        <p>
          Eye Magazine n°80 Summer, 2011
        </p>
        <p id="title">
          <a href="http://motionographer.com/2009/10/16/the-animated-life-work-of-jeff-scher/">The Animated Life of Jeff Scher</a>
        </p>
        <p>
          Motionographer. 2009
        </p>
        <p id="title">
          <a href="https://theaoi.com/varoom/back-issues/back-issues/varoom-08/">Mapping The Terrain: Not Static</a>
        </p>
        <p>
          Varoom The Journal of Illustration. Issue 07, 2008
        </p>
        <p id="title">
          Motion Blur 2 - Book Review
        </p>
        <p>
          Varoom The Journal of Illustration. Issue 06, 2008
        </p>
        <p id="title">
          <a href="https://theaoi.com/varoom/back-issues/back-issues/varoom-05/">Mario Hugo A Modern Romantic</a>
        </p>
        <p>
          Varoom The Journal of Illustration. Issue 05, 2007
        </p>
     
      </div>
     


    </Layout>
  )
}

export default AboutPage
